var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"fw-bold white--text",attrs:{"color":_vm.color}},'v-chip',attrs,false),on),[_vm._t("default")],2)]}}],null,true),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',[_vm._v(_vm._s(_vm.content))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }